import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DefaultFallbackComponent({
  error: __,
  resetErrorBoundary: ___
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    padding: "1000",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "errors/general",
      height: 200,
      marginBlock: "1000"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.errorPage.default.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockEnd: "1000",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "pricingPage.pages.errorPage.default.paragraph_jsx"
      })
    })]
  });
}